(function () {
  function initHero(hero) {
    if (!hero || hero.dataset.bound === "1") return;
    hero.dataset.bound = "1";

    /* NEW: whole hero clickable -> About */
    var heroLink = hero.getAttribute("data-hero-link");
    if (heroLink) {
      hero.style.cursor = "pointer";
      hero.addEventListener("click", function (e) {
        // ignore modified clicks
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        // avoid hijacking clicks on actual links/buttons if any are added later
        var t = e.target;
        if (t && t.closest && t.closest("a, button, input, textarea, select, [role='button']")) return;

        window.location.href = heroLink;
      });
    }

    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var delay = Math.max(0, parseFloat(hero.getAttribute("data-video-delay") || "2"));
    var gap = Math.max(0, parseFloat(hero.getAttribute("data-rotate-gap") || "2"));

    var items = Array.prototype.slice.call(hero.querySelectorAll("[data-video-item]"));
    if (!items.length) return;

    function getVideo(item) {
      return item ? item.querySelector("video") : null;
    }

    function ensureSrc(v) {
      if (!v) return;
      if (v.getAttribute("src")) return;
      var s = v.getAttribute("data-src");
      if (s) v.setAttribute("src", s);
    }

    function hideAll() {
      items.forEach(function (it) {
        it.classList.remove("is-active");
        var v = getVideo(it);
        if (v) {
          try { v.pause(); } catch (e) {}
          v.currentTime = 0;
        }
      });
    }

    function playItem(i) {
      hideAll();

      var it = items[i];
      if (!it) return;

      it.classList.add("is-active");

      var v = getVideo(it);
      if (!v) return;

      ensureSrc(v);
      v.muted = true;
      v.playsInline = true;

      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    var index = 0;

    window.setTimeout(function () {
      hero.classList.add("is-video-on");

      function next() {
        playItem(index);

        var v = getVideo(items[index]);
        var durationMs = 6000;

        if (v) {
          if (isFinite(v.duration) && v.duration > 0) {
            durationMs = Math.max(1000, v.duration * 1000 - 120);
          } else {
            var onMeta = function () {
              if (isFinite(v.duration) && v.duration > 0) {
                durationMs = Math.max(1000, v.duration * 1000 - 120);
              }
              v.removeEventListener("loadedmetadata", onMeta);
            };
            v.addEventListener("loadedmetadata", onMeta);
          }
        }

        window.setTimeout(function () {
          hideAll();
          window.setTimeout(function () {
            index = (index + 1) % items.length;
            next();
          }, gap * 1000);
        }, durationMs);
      }

      next();
    }, delay * 1000);
  }

  function boot(root) {
    (root || document).querySelectorAll(".orsa-hero[data-video-delay]").forEach(initHero);
  }

  document.addEventListener("DOMContentLoaded", function () { boot(document); });
  document.addEventListener("shopify:section:load", function (e) { boot(e && e.target ? e.target : document); });
})();
